module.exports = global["$"] = require("-!/Users/tuananhbui/Documents/Code/wat-dat-pho/node_modules/expose-loader/index.js?jQuery!./jquery.js");


//////////////////
// WEBPACK FOOTER
// ./node_modules/jquery/dist/jquery.js-exposed
// module id = 7
// module chunks = 0